import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type GetTextMessagesContentQueryVariables = GraphQLTypes.Exact<{
  idsByTarget: Array<GraphQLTypes.TextMessagesInput> | GraphQLTypes.TextMessagesInput;
}>;

export type GetTextMessagesContentQueryResult = { __typename?: 'Query' } & {
  activityFeed: { __typename?: 'ActivityFeed' } & {
    textMessages?: GraphQLTypes.Maybe<
      Array<{ __typename?: 'TextMessage' } & Pick<GraphQLTypes.TextMessage, 'archivedAt' | 'content' | 'id'>>
    >;
  };
};

export const GetTextMessagesContentDocument = gql`
  query getTextMessagesContent($idsByTarget: [TextMessagesInput!]!) {
    activityFeed {
      textMessages(idsByTarget: $idsByTarget) {
        archivedAt
        content
        id
      }
    }
  }
`;
